<!-- @format -->

<div *ngIf="hasValue">
  <sis-localized-markup-string-view
    *ngIf="localizedMarkupStringValue"
    [language]="language"
    [content]="localizedMarkupStringValue"></sis-localized-markup-string-view>
  <span *ngIf="localizedStringValue">{{ localizedStringValue | localizedString: language }}</span>
</div>
<span *ngIf="!hasValue">
  <sis-icon icon="alert-fill-attention"></sis-icon>
  <span class="sis-placeholder" translate="STUDIES.COURSE_UNIT_INFO_MODAL.NO_CONTENT_IN_SELECTED_LANGUAGE"></span>
</span>
